/// <reference path="../../components/commonClasses/common.interface.ts" />
/// <reference path="../../components/commonClasses/commonDataServiceBase.ts" />

module Meevo.Components.Common {
    export class CompensationSettingsService extends Meevo.Components.CommonClasses.CommonDataServiceBase implements Meevo.Components.CommonClasses.ICompensationSettingsService {
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings, protected $http: angular.IHttpService, protected $q: ng.IQService) {
            super(appSettings, $http);
        }

        /**
         * Get settings
         * @returns {ng.IPromise} promise
         */
        getSettings(settingsType: Model.BusinessSettingCategoryEnum, includeMetadata: boolean = true): ng.IPromise<any> {
            return this.customMethodData(`/api/Settings/${Model.BusinessSettingCategoryEnum[settingsType]}?includeMetadata=${includeMetadata}`, 'GET', null).then((response) => {
                return response.data;
            });
        }

        saveSettings(settingType: Model.BusinessSettingCategoryEnum, settings: {}, includeMetadata: boolean = true): ng.IPromise<any> {
            let period: Meevo.Model.PeriodSettings = settings;
            return this.customMethodData(`/api/Settings/${Model.BusinessSettingCategoryEnum[settingType]}/?includeMetadata=${includeMetadata}`, 'POST', settings).then((response: any) => {
                return response.data;
            });
        }

        getPayPeriodMostRecentStartDate(): ng.IPromise<any> {

            return this.customMethodData(`/api/Payroll/PayPeriodMostRecentStartDate`, 'GET', '').then((response: any) => {
                return response.data;
            });
        }

        getPayrollSettings(includeMetadata: boolean = true): angular.IPromise<Meevo.Model.IPayrollSettings> {
            return this.$q.all([this.getPeriodSettings(includeMetadata), this.getPeriodDetails()])
                .then((response: any) => {
                    let payrollSettings: Meevo.Model.IPayrollSettings = { periodSettings: null, periodDetails: null };
                    payrollSettings.periodSettings = <Meevo.Model.PeriodSettings>response[0];
                    payrollSettings.periodDetails = <Meevo.Model.IPeriodDetails[]>response[1];
                    return payrollSettings;
                });
        }

        private getPeriodSettings(includeMetadata: boolean): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/Settings/Period/?includeMetadata=${includeMetadata}`)
                .then((response) => response.data);
        }

        private getPeriodDetails(): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/Payroll/Period`)
                .then((response) => response.data);
        }


        static factory(): Function {
            let svc = (appSettings: Meevo.Components.Common.IAppSettings, $http: angular.IHttpService, $q: ng.IQService) => {
                return new CompensationSettingsService(appSettings, $http, $q);
            }

            svc.$inject = ["meevo.AppSettings", "$http", "$q"];
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.CompensationSettingsService", CompensationSettingsService.factory());
}